export const processing = {
  'processing.startingAI': 'Démarrage du traitement IA...',
  'processing.processingWithAI': 'Traitement avec IA...',
  'processing.aiComplete': 'Traitement IA terminé',
  'processing.extractedDataFrom': 'Données extraites de',
  'processing.aiProcessingFailed': 'Échec du traitement IA',
  'processing.aiProcessing': 'Traitement IA en cours...',
  'processing.overallProgress': 'Progression globale',
  'processing.formGeneration': 'Génération de formulaire en cours...',
  'processing.autoCompleting': 'Remplissage automatique du formulaire...',
  'processing.submittingApplication': 'Soumission de la candidature...',
  'processing.processingApplication': 'Traitement de la candidature...'
} as const;